export enum ColumnKey {
    Chip = 'chip',
    Time = 'time',
    Score = 'score',
    Location = 'location',
    Sex = 'sex',
    SectionName = 'SectionName',
    RollName = 'RollName',
    Name = 'name',
    Number = 'number',
    Club = 'club',
    Country = 'country',
}

interface ColumnDefinition {
    description: string;
    key: ColumnKey;
    width?: string;
    textAlign?: 'left' | 'right' | 'center';
}

export const ColumnDefinitions: ColumnDefinition[] = [
    {
        description: 'שבב',
        key: ColumnKey.Chip,
    },
    {
        description: 'שעון ישראל',
        key: ColumnKey.Time,
        textAlign: 'center',
    },
    {
        description: 'מדינה',
        key: ColumnKey.Country,
        textAlign: 'center',
    },
    {
        description: 'מספר חזה',
        key: ColumnKey.Number,
        textAlign: 'left',
    },
    {
        description: 'שם',
        key: ColumnKey.Name,
        textAlign: 'left',
    },
    {
        description: 'קטגוריה',
        key: ColumnKey.SectionName,
        textAlign: 'left',
    },
    {
        description: 'תוצאה',
        key: ColumnKey.Score,
        textAlign: 'center',
    },
    {
        description: 'אגודה',
        key: ColumnKey.Club,
        width: '300px',
        textAlign: 'right',
    },
    {
        description: 'location',
        key: ColumnKey.Location,
    },
    {
        description: 'מגדר',
        key: ColumnKey.Sex,
        textAlign: 'center',
    },

    {
        description: 'מקצה',
        key: ColumnKey.RollName,
        textAlign: 'right',
    }
]